/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useMemo } from 'react';
import { Alert, Modal } from '@brokerbay/design-components';
import styled from 'styled-components';
import { Typography } from 'antd';
import BillingPlanCard from './BillingPlanCard';

const { Link, Title, Text } = Typography;

type ManagePlanModalProps = {
  onClose: () => void;
  visible: boolean;
  orgPlanPrice: number;
};

const ManagePlanModal: React.FC<ManagePlanModalProps> = ({
  onClose,
  visible,
  orgPlanPrice,
}) => {
  const billingPlans = useMemo(
    () => [
      {
        plan: 'AGENT',
        price: 0,
        descriptions: [
          { text: 'Online MLS Booking Portal' },
          {
            text: 'Third-Party Front-Desk API Integrations',
          },
          { text: 'Mobile & Desktop Apps' },
          { text: 'Electronic Lockbox Management' },
        ],
      },
      {
        plan: 'BROKERAGE',
        price: orgPlanPrice,
        descriptions: [
          { text: 'Full Brokerage Showing System' },
          {
            text: 'Interactive 3D Virtual Showings',
          },
          { text: 'Admin Management Features' },
          { text: 'InterBrokerage Chat System' },
          { text: 'Everything on the Agent Plan', includedFeature: true },
        ],
      },
    ],
    [orgPlanPrice],
  );

  return (
    <Modal
      open={visible}
      title="Manage Your Plan"
      footer={null}
      onCancel={onClose}
      width={768}
      focusTriggerAfterClose={false}
      data-cy="manage-plan-modal"
    >
      <Title level={2}>Your Plan</Title>
      <Text type="secondary">
        Your brokerage currently has access to BrokerBay&rsquo;s complete
        front-desk showing ecosystem and other premium features.
      </Text>

      <StyledAlert
        type="info"
        banner
        message={
          <Text>
            To modify or cancel this launch date after saving, you will have to
            contact
            <Link href={`mailto:${'support@brokerbay.com'}`}>
              {' '}
              {'support@brokerbay.com'}
            </Link>
          </Text>
        }
      />
      <StyledCardContainer>
        {billingPlans.map((billingPlan, index) => (
          <BillingPlanCard key={index} billingPlan={billingPlan} />
        ))}
      </StyledCardContainer>
    </Modal>
  );
};

const StyledAlert = styled(Alert)`
  margin: 16px 0;
`;

const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-items: center;
`;

export default ManagePlanModal;
